import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import type { GridColDef, GridRowId } from '@mui/x-data-grid-pro';
import { GridToolbar } from '@mui/x-data-grid-pro';

import MappingQualificationsDialog from './MappingQualificationsDialog';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

type Props = {
  regionalPoolTenantName: string | null;
};

export default function MappingFunctionsGrid({
  regionalPoolTenantName
}: Props) {
  const { t } = useTranslation('common');

  const [open, setOpen] = useState(false);
  const [regionalPoolQualificationId, setRegionalPoolQualificationId] =
    useState<string | undefined>();

  const [pageSize, setPageSize] = useState(10);

  const [tenantQualificationId, setTenantQualificationId] = useState('');
  const { data } = queries.useGetRegionalPoolQualificationMappings(
    regionalPoolTenantName as string,
    { enabled: !!regionalPoolTenantName }
  );

  const columns: GridColDef[] = [
    {
      field: 'tenantQualificationName',
      headerName: t('qualificationRequest'),
      flex: 1
    },
    {
      field: 'regionalPoolQualificationName',
      headerName: t('qualificationRegionalPool'),
      flex: 1
    }
  ];

  const rows =
    data?.map((r) => ({
      id: r.tenantQualificationId,
      regionalPoolQualificationId: r.regionalPoolQualificationId,
      tenantQualificationName: r.tenantQualificationName,
      regionalPoolQualificationName: r.regionalPoolQualificationName
    })) ?? [];

  function handleEditClick(id: GridRowId, row) {
    setRegionalPoolQualificationId(row.regionalPoolQualificationId);
    setTenantQualificationId(id as string);
    setOpen(true);
  }
  return (
    <>
      <TableCRUDLayout
        title={t('mappingQualifications')}
        columns={columns}
        shouldRenderToolBar={false}
        hideCreateAction
        renderFormContainer={false}
        editable={false}
        rows={rows}
        editMode="row"
        pagination
        pageSize={pageSize}
        pageSizeOptions={[10, 20, 50]}
        onPaginationModelChange={({ pageSize }) => setPageSize(pageSize)}
        onEditClick={handleEditClick}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          }
        }}
        addRowDialog={
          <MappingQualificationsDialog
            title="Kwalificatie regiopool bewerken"
            open={open}
            setOpen={setOpen}
            regionalPoolQualificationId={regionalPoolQualificationId}
            setRegionalPoolQualificationId={setRegionalPoolQualificationId}
            regionalPoolTenantName={regionalPoolTenantName as string}
            tenantQualificationId={tenantQualificationId}
          />
        }
      />
    </>
  );
}
